import { FlowNode } from "../node-manager";
import { DependentNode } from "./dependent-node";

// BaseLength of the node dimensions. so if relative height is 3 and relative width is 5, the actual height will be 150px and width will be 250px.
export const NODES_BASE_LENGTH = 50;

export class BaseNode {
    variant = FoblexNode.Variant.Base;
    type:string;
    resourceId?: number;
    id:number;
    position: FoblexNode.Position;
    dimension: FoblexNode.Dimension;
    inputId?: string;
    outputId?: string;

    constructor(
        id:number,
        height: number,
        width: number,
        resourceId: number,
        type: string,
        position: FoblexNode.Position = { x: 50, y: 50 },
    ) {
        this.id = id;
        this.position = position;
        this.dimension = { height, width };
        this.resourceId = resourceId;
        this.type = type;
    }
}

export namespace FoblexNode {
    export enum Variant {
        Base = 'base',
        Dependent = 'dependent'
    }

    export enum Place {
        Top,
        TopRight,
        TopLeft,
        Right,
        Left,
        Bottom,
        BottomRight,
        BottomLeft,
    }

    export interface Position {
        x: number;
        y: number;
    }

    export interface Dimension {
        height: number;
        width: number;
    }

    export function isBaseNode(node: FlowNode): node is BaseNode {
        return node.variant === FoblexNode.Variant.Base;
    }
      
    export function isDependentNode(node: FlowNode): node is DependentNode {
        return node.variant === FoblexNode.Variant.Dependent;
    }
}